/*
Author: Vaishnavi
Date: 27/11/2019
Issue Description: Spacing fixes done as per design guidelines
*/
/*
Author: Shivakumar
Date: 06/12/2019
Issue Description: [Retirement Settings] Error message should not be displayed by default.
search_string: PL-2048
*/

/*
Author: Vinod
Date: 20/01/2020
Issue Description: In Retirement Criteria Drop Down Selecting as Specific Date, While Selecting Date and Month Displaying Alert Message.
search_string: PL-2460
*/

/*
Author: Vinod
Date: 21/01/2020
Issue Description: When Specific Date is picked up it should allow multiple Months also.
search_string: PL_2484
*/

/*
Author: Shivakumar
Date: 08/04/2020
Issue Description: [Retirement Setting] - Need to add Plus icon when selected Specific date.
search_string: PL_2832
*/

/*
Author: Shivakumar
Date: 13/04/2020
Issue Description: Misc - Retirement setting] Validation UI issues
search_string: PL_3052
*/

/*
Author: Shivakumar
Date: 13/04/2020
Issue Description: Misc - Retirement setting] Validation UI issues
search_string: PL_3054
*/


<template>
  <div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    ></toast-message>
    <!-- Start PL-2048 -->
    <div class="row">
      <div class="col-3 padding-l-n">
        <txt
          type="text"
          id="age"
          label="Enter Age of Retirement *"
          v-model="formData.age"
          name="age"
          v-numeric-only
          maxlength="100"
          v-validate="{required:true,max_value: 100}"
          :classname="errors.has('age')"
          :errormsg="errors.first('age')"
        />
      </div>
    </div>
    <!-- End PL-2048 -->
    <div class="row margin-t-m">
      <div class="col-3 padding-l-n">
        <tl-select
          labelText="name"
          label="Retirement Criteria *"
          name="retirementCriteriaSelection"
          v-model="formData.retirementCriteria"
          :options="retirementCriteriaOptions"
          :reduce="filter => `${filter.name}`"
          :placeholder="'Select'"
          @change="(val)=>{formData.retirementCriteria = val; changeRetirementCriteriaVal(val)}"
          ref="retirementCriteria"
          data-vv-as="retirement criteria"
          v-validate="{required: true}"
          :classname="errors.has('retirementCriteriaSelection')"
          :errormsg="errors.first('retirementCriteriaSelection')"
        />
      </div>
    </div>
    <!-- PL_2832 -->
    <!-- PL_3054 -->
    <div v-if="formData.retirementCriteria && formData.retirementCriteria.value == 'specific_date'">
      <div v-for="(dateObj, index) in specificDatesArray" :key="index">
        <div class="customThreeColumnGrid margin-t-m">
          <div class="padding-right-15">
            <tl-select
              :name="'monthSelection'+index"
              label="Select Month *"
              labelText="name"
              v-model="specificDatesArray[index].month"
              :options="retirementMonthOptions"
              :reduce="filter => `${filter.name}`"
              @change="(val)=> {specificDatesArray[index].month = val; changeMonth(index,val)}"
              data-vv-as="month"
              v-validate="{required: formData.retirementCriteria && formData.retirementCriteria.value == 'specific_date' ? true : false}"
              :classname="errors.has('monthSelection'+index)"
              :errormsg="errors.first('monthSelection'+index)"
            />
          </div>
          <div class="padding-right-15">
            <tl-select
              :name="'daySelection'+index"
              label="Select Day *"
              v-model="specificDatesArray[index].date"
              :options="Array.from(Array(getDaysOfMonth(specificDatesArray[index].month)).keys(), val=>val+1)"
              :reduce="filter => `${filter.name}`"
              @change="(val)=> {specificDatesArray[index].date = val; changeDaysOfMonth(index,val)}"
              :disabled="!(specificDatesArray[index].month)"
              data-vv-as="day"
              v-validate="{required: formData.retirementCriteria && formData.retirementCriteria.value == 'specific_date' ? true : false}"
              :classname="errors.has('daySelection'+index)"
              :errormsg="errors.first('daySelection'+index)"
            />
          </div>
          <div class="buttonsBox">
            <img
              v-if="(index+1) == specificDatesArray.length"
              class="addBtn"
              src="@/assets/group-5.svg"
              @click="addNewSpecificDateSet()"
              :disabled="specificDatesArray.length == 5"
            />
            <img
              class="deleteBtn"
              src="/img/delete.475f9da9.svg"
              @click="deleteSpecificDateSet(index)"
              :disabled="specificDatesArray.length == 1"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- PL_2832 -->

    <tick-animation v-if="showSuccessMsg"></tick-animation>

    <bottom-action-container class="placeAtEnd">
      <btn-skip @navClicked="$emit('skip')"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="$emit('previous')" />
          <btn text="Next" type="primary" @click="addRetirementData" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import {
  monthOptionsObj,
  retirementConstants
} from "../../../../../../apis/constants.js";
export default {
  mounted() {
    this.fetchAll();
  },
  activated() {
    this.fetchAll();
  },
  computed: {
    ...mapState("onboard/retirementSettings", {
      retirementSettingsData: state => state.data,
      isFetching: state => state.isFetching,
      isSaving: state => state.isSaving,
      isDeleting: state => state.isDeleting
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
    isLoading() {
      return this.isFetching;
    }
  },
  data() {
    return {
      mode: "add",
      showBtn: true,
      editMode: false,
      toast: false,
      errmsg: "",
      isSpecificDateSelected: false,
      specificDatesArray: [],
      formData: {
        age: "",
        retirementCriteria: null
      },
      retirementCriteriaOptions: retirementConstants.retirementCriteriaOptions,
      retirementMonthOptions: monthOptionsObj.yearMonths,
      showSuccessMsg: false
    };
  },
  methods: {
    ...mapActions("onboard/retirementSettings/", {
      act_fetchAll: "fetchAll",
      act_create: "create"
    }),
    /** Function to fetch data from server and to fill the form data */
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.le_id);
        if (Object.keys(res.data.payload.data).length) {
          this.editMode = true;
          this.formData.age = res.data.payload.data.ageOfRetirement;
          this.formData.retirementCriteria = this.retirementCriteriaOptions.find(
            item => item.value == res.data.payload.data.criteria
          );
          this.changeRetirementCriteriaVal(this.formData.retirementCriteria);
          // PL_2832
          if (this.formData.retirementCriteria.name == "Specific Date") {
            let specificDatesArr = res.data.payload.data.specificDates;
            if (specificDatesArr.length) {
              this.specificDatesArray = [];
              specificDatesArr.forEach(item => {
                this.specificDatesArray.push({
                  date: item.day ? this.setDateAsPerId(item.day) : null,
                  month: item.month ? this.setMonthsAsPerId(item.month) : null
                });
              });
            }
          }
          // PL_2832
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to fetch number of days present in that respective month */
    //PL_3054
    getDaysOfMonth(monthObj) {
      try {
        let numOfMonthDays = 0;
        if (monthObj && monthObj) {
          switch (monthObj.id) {
            case 1:
              numOfMonthDays = 31;
              break;
            case 2:
              numOfMonthDays = 28;
              break;
            case 3:
              numOfMonthDays = 31;
              break;
            case 4:
              numOfMonthDays = 30;
              break;
            case 5:
              numOfMonthDays = 31;
              break;
            case 1:
              numOfMonthDays = 31;
              break;
            case 6:
              numOfMonthDays = 30;
              break;
            case 7:
              numOfMonthDays = 31;
              break;
            case 8:
              numOfMonthDays = 31;
              break;
            case 9:
              numOfMonthDays = 30;
              break;
            case 10:
              numOfMonthDays = 31;
              break;
            case 11:
              numOfMonthDays = 30;
              break;
            case 12:
              numOfMonthDays = 31;
              break;

            default:
              break;
          }
        }
        return numOfMonthDays;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to return date value from string to Number */
    setDateAsPerId(dateId) {
      try {
        if (dateId) {
          return Number(dateId);
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Function to return month object to set in drop down values as per the month id */
    setMonthsAsPerId(monthId) {
      try {
        if (Number(monthId) == 1) {
          return { name: "January", id: 1 };
        } else if (Number(monthId) == 2) {
          return { name: "February", id: 2 };
        } else if (Number(monthId) == 3) {
          return { name: "March", id: 3 };
        } else if (Number(monthId) == 4) {
          return { name: "April", id: 4 };
        } else if (Number(monthId) == 5) {
          return { name: "May", id: 5 };
        } else if (Number(monthId) == 6) {
          return { name: "June", id: 6 };
        } else if (Number(monthId) == 7) {
          return { name: "July", id: 7 };
        } else if (Number(monthId) == 8) {
          return { name: "August", id: 8 };
        } else if (Number(monthId) == 9) {
          return { name: "September", id: 9 };
        } else if (Number(monthId) == 10) {
          return { name: "October", id: 10 };
        } else if (Number(monthId) == 11) {
          return { name: "November", id: 11 };
        } else if (Number(monthId) == 12) {
          return { name: "December", id: 12 };
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On change of day value drop down */
    //PL_3052
    changeDaysOfMonth(index, val) {
      try {
        if (!val) {
          this.specificDatesArray[index].date = null;
        }
        this.$validator.reset();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On change of Month value drop down */
    //PL_3052
    changeMonth(index, val) {
      try {
        if (!val) {
          this.specificDatesArray[index].month = null;
        }
        this.$validator.reset();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Function to create a new month & day set on Plus icon click */
    addNewSpecificDateSet() {
      try {
        if (this.specificDatesArray.length <= 5) {
          this.specificDatesArray.push({
            date: null,
            month: null
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Function to delete a existing month & day set on delete icon click */
    deleteSpecificDateSet(index) {
      try {
        if (index > -1) {
          this.specificDatesArray.splice(index, 1);
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    cancel() {
      this.showBtn = true;
    },
    /** On change of Retirement Criteria drop down value clicks */
    changeRetirementCriteriaVal(val) {
      try {
        if (val) {
          this.specificDatesArray = [];
          if (val.name == "Specific Date") {
            this.isSpecificDateSelected = true;
            this.specificDatesArray = [
              {
                date: null,
                month: null
              }
            ];
          } else {
            this.isSpecificDateSelected = false;
          }
        } else {
          this.formData.retirementCriteria = null;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Function to validate the form data */
    addRetirementData() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
    },
    /** Function to submit the form data to server */
    async performAction() {
      try {
        let specificDatesArr = [];
        if (this.formData.retirementCriteria.name == "Specific Date") {
          if (this.checkIsMonthsDuplicated()) {
            this.toast = true;
            this.errmsg = "You can't select same month multiple times";
            return;
          } else {
            this.toast = false;
            this.errmsg = "";
          }
          this.specificDatesArray.forEach(item => {
            specificDatesArr.push({
              day: item.date
                ? item.date.toString().length == 1
                  ? "0" + item.date.toString()
                  : item.date.toString()
                : null,
              month: item.month
                ? item.month.id.toString().length == 1
                  ? "0" + item.month.id.toString()
                  : item.month.id.toString()
                : null
            });
          });
        }
        let obj = {
          data: {
            le_id: this.le_id,
            ageOfRetirement: Number(this.formData.age),
            criteria: this.formData.retirementCriteria.value,
            specificDates: specificDatesArr
          }
        };
        this.$root._data.isSaving = true;
        let res = await this.act_create(obj.data);
        setTimeout(() => {
          if (res.data.status) {
            this.showSuccessMsg = true;
            this.editMode = true;
            this.hideSuccessMsg();
          }
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },
    /* function to hide success message and navigate to next screen */
    hideSuccessMsg() {
      setTimeout(() => {
        this.showSuccessMsg = false;
        this.$emit("next");
      }, 1000);
    },
    /** Function to check whether the same month is selected  
     * more than once in the dropdown set of Specific date on Retirement Criteria dropdown value */
    // PL_2832
    checkIsMonthsDuplicated() {
      try {
        var monthsListArray = this.specificDatesArray.map(function(item) {
          return item.month;
        });
        let uniqueArray = [];
        uniqueArray = [...new Set(monthsListArray.map(a => a.name))];// To remove the duplicates
        if (monthsListArray.length != uniqueArray.length) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
    // PL_2832
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss";

.customThreeColumnGrid {
  grid-template-columns: 25% 25% 25%;
  display: grid;
  grid-row-gap: 15px;
  grid-column-gap: 20px;
}
.buttonsBox {
  padding: 24px 0px 0px 0px;
}

.addBtn {
  margin: 0px 10px 0px 0px;
  cursor: pointer;
}
.deleteBtn {
  cursor: pointer;
  margin: 5px 0px 5px 0px;
}
.padding-right-15 {
  padding-right: 15px;
}
</style>

